import React from "react";
import {AppBookingWeeksAutocomplete} from "../../../Autocomplete";


export default function AppCommonFiltersBookingWeeks({ ...props }) {

    return <AppBookingWeeksAutocomplete
        error={props?.error}
        {...props}
    />
}